import * as yup from 'yup';
import '@availity/yup';

export default yup.object().shape({
  name: yup.string().required('Name is required'),
  description: yup.string(),
  demTemplateId: yup.string().required(),
  campaignId: yup.string().required('Select a campaign'),
  landingPageUrl: yup.string().url().required(),
  utmSource: yup.string(),
  utmMedium: yup.string(),
  utmCampaign: yup.string(),
});
